import styled from "styled-components";
export default {
    FormContainer: styled.div `
    && {
      grid-row-gap: ${({ theme }) => theme["grid-gap-12"]};
      grid-column-gap: ${({ theme }) => theme["grid-gap-12"]};
    }

    > *:nth-child(5),
    > *:last-child {
      grid-column: span 2;
    }
  `
};
